import { ComponentType } from 'react';
import { IconName } from '../components/display/Icon';
import AccountRouter from './account';
import Account from './account/store/Account';
import BundlesRouter from './bundles';
import DebugRouter from './debug';
import LoginRouter from './login';
import type { RoleCheckMode } from './login/store/AuthSession';
import ProductsRouter from './products';
import PromotionsRouter from './promotions';
import PulseKeysRouter from './pulse-keys';
import PulseCdnRouter from './pulsecdn';
import SettingsPage from './settings/SettingsPage';
import StatisticsRouter from './statistics';
import UsersRouter from './users';
import { Role } from './users/store/User';

export default function getAllRoutes(): Route[] {
  return allRoutes;
}

export function getMenuRoutes(
  dependencies: AvailableCheckDependencies,
): Route[] {
  return allRoutes
    .filter((route) => {
      return (
        route.menuPosition &&
        (!route.minRole || dependencies.userHasRole(route.minRole)) &&
        (!route.isAvailable || route.isAvailable(dependencies))
      );
    })
    .toSorted((a, b) => {
      return (a.menuPosition || 0) - (b.menuPosition || 0);
    });
}

const allRoutes: Route[] = [
  {
    route: '/account',
    title: 'Account',
    icon: 'user',
    component: AccountRouter,
    menuPosition: 1,
    minRole: 'PROVIDER',
  },
  {
    route: '/bundles',
    title: 'Bundles',
    icon: 'cubes',
    component: BundlesRouter,
    menuPosition: 3,
    minRole: 'PROVIDER',
    isAvailable({ account }) {
      return Boolean(account?.configurations?.isWebhookEnabled);
    },
  },
  {
    route: '/debug',
    title: 'Debug',
    icon: 'bug',
    component: DebugRouter,
    minRole: 'ADMIN',
  },
  {
    route: '/login',
    title: 'Login',
    icon: 'user',
    component: LoginRouter,
    authRoute: true,
    noLayout: true,
  },
  {
    route: '/products',
    title: 'Products',
    icon: 'cube',
    component: ProductsRouter,
    menuPosition: 2,
    minRole: 'PROVIDER',
  },
  {
    route: '/promotions',
    title: 'Promotions',
    icon: 'percentage',
    component: PromotionsRouter,
    menuPosition: 6,
    minRole: 'PROVIDER',
  },
  {
    route: '/pulse-keys',
    title: 'Pulse Keys',
    icon: 'barcode',
    component: PulseKeysRouter,
    menuPosition: 4,
    minRole: 'PROVIDER',
  },
  {
    route: '/pulsecdn',
    title: 'PulseCDN',
    icon: 'cloud',
    component: PulseCdnRouter,
    minRole: 'PROVIDER',
    noLayout: true,
  },
  {
    route: '/settings',
    title: 'Settings',
    icon: 'cog',
    component: SettingsPage,
    menuPosition: 8,
    minRole: 'ADMIN',
  },
  {
    route: '/statistics',
    title: 'Statistics',
    icon: 'chart-pie',
    component: StatisticsRouter,
    menuPosition: 5,
    minRole: 'PROVIDER',
  },
  {
    route: '/users',
    title: 'Users',
    icon: 'users',
    component: UsersRouter,
    menuPosition: 7,
    minRole: 'ADMIN',
  },
];

export interface Route {
  authRoute?: boolean;
  component: { noLayout?: boolean } & ComponentType<any>;
  icon: IconName;
  isAvailable?: ({ account }: AvailableCheckDependencies) => boolean;
  menuPosition?: number;
  minRole?: Role;
  noLayout?: boolean;
  route: string;
  title: string;
}

export interface AvailableCheckDependencies {
  account?: Account;
  userHasRole: (role: Role, options?: { mode?: RoleCheckMode }) => boolean;
}
